import Rest from '@services/Rest';

/**
 * @typedef {SalesService}
 */
export default class SalesService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/sale-analysis'
}
